import dataSources from 'dataSources';
import { batch } from 'react-redux';
import { AppThunk } from 'store';
import { StatusLoading } from 'common/constants';
import { STATUS_LOADING } from 'common/constants';
import { getResponseError, handleApiErrors } from 'common/utils/index';
import { getArrayToObject } from 'common/utils/directionsService/utils';

import slice from '../reducer/slice';
import appSlice from '../../application/reducer/slice';
import { IStationFilter } from '../types/stationFilter';
import { STATE } from '../types/state';
import { mappingStationsByCode } from '../utils';
import directoriesSlice from '../../directories/reducer/slice';
import { STATE as FUEL_CARDS_STATE } from '../../fuelCards/types';
import {
  AvailabilityType,
  FuelType,
} from 'pages/Map/components/FuelAvailabilityButton/constants';
import makeRestrictionsPayload from 'pages/Map/components/FuelAvailabilityButton/utils/makeRestrictionsPayload';

type TOperation = (
  filter: IStationFilter & {
    restrictions?: {
      serviceNtType: FuelType;
      mode: AvailabilityType;
    };
  },
  isAutoscaling?: boolean,
) => AppThunk;

const {
  setFilterStatusLoading,
  setIsLoadingStations,
  setFilter,
  setStations,
  setActionStations,
  setActionStationsFitBounds,
  setStationsFitBounds,
} = slice.actions;
const { setError } = appSlice.actions;
const { updateRoadsideServices } = directoriesSlice.actions;

const operation: TOperation =
  (filter, isAutoscaling = true) =>
  async (dispatch, getState) => {
    try {
      batch(() => {
        dispatch(setFilterStatusLoading(STATUS_LOADING.load));
        dispatch(setIsLoadingStations(StatusLoading.Load));
      });

      const state = getState();
      const {
        stations: prevStations,
        allStations: { dataMap: allStationsMap },
        restrictions,
      } = state[STATE];

      const { activeFuelCard } = state[FUEL_CARDS_STATE].fuelCards;

      const searchResponse = await dataSources.stations.getStationCodes({
        ...filter,
        ...makeRestrictionsPayload({
          fuel: restrictions.serviceNtType,
          availability: restrictions.mode,
          statuses: restrictions.statuses,
        }),
        ...(activeFuelCard ? { fullCardNumber: activeFuelCard } : {}),
      });

      // Handle errors from the response
      handleApiErrors(searchResponse?.errors, dispatch, setError);

      const data = searchResponse?.stations || [];

      const {
        stations,
        actionStations,
        stationsBBox,
        actionStationsBBox,
        serviceCodes, //@ts-ignore
      } = await mappingStationsByCode(data, allStationsMap, prevStations.data);

      const prevServiceCodes = Object.keys(filter?.roadsideServices || {});

      const roadsideServices = serviceCodes.length
        ? getArrayToObject(
            serviceCodes.filter((code) => prevServiceCodes.includes(`${code}`)),
          )
        : filter?.roadsideServices;

      batch(() => {
        dispatch(setFilterStatusLoading(STATUS_LOADING.done));
        dispatch(setIsLoadingStations(StatusLoading.Done));
        if (isAutoscaling) dispatch(setStationsFitBounds(stationsBBox));
        dispatch(setActionStationsFitBounds(actionStationsBBox));
        dispatch(
          setFilter({
            ...filter,
            roadsideServices,
          }),
        );
        dispatch(setStations(stations));
        dispatch(setActionStations(actionStations));
        dispatch(
          updateRoadsideServices({
            roadsideServiceKeys: serviceCodes,
          }),
        );
      });
    } catch (e) {
      console.info(e);
      const error = await getResponseError(e);
      dispatch(setError(error));
      dispatch(setFilterStatusLoading(STATUS_LOADING.error));
      dispatch(setIsLoadingStations(StatusLoading.Error));
    }
  };

export default operation;
